import { render } from "./img_fixed_ingles.vue?vue&type=template&id=512ee141&scoped=true"
import script from "./img_fixed_ingles.vue?vue&type=script&lang=js"
export * from "./img_fixed_ingles.vue?vue&type=script&lang=js"

import "./img_fixed_ingles.vue?vue&type=style&index=0&id=512ee141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512ee141"]])

export default __exports__